import videojs from 'video.js';
const Component = videojs.getComponent('Component');
const ModalDialog = videojs.getComponent('ModalDialog');

const dom = videojs.dom || videojs;

const DEFAULTS = {
	onDetected: function lowQuality(player) {
		player.on('vast.contentStart', () => {
			if (player.quality_handler) player.quality_handler.forceLowQuality();
		});
	},
	caption: 'AdBlockers warning',
	message: 'Off adBlockers to watch normaly',
	detectClass: 'AdInline',
	detectLink: '',
	detectStatUrl: ''
};

/**
 * The dialog component for showing adblockers message
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends ModalDialog
 */
class AdBlockersDetectorMessage extends ModalDialog {
	constructor(player, options) {
		let options_ = Object.assign({}, DEFAULTS, options); 
		options_.uncloseable = true;
		super(player, options_);
		this.options = options_;
		this.hide();
		this.init();
	}

	setListeners_() {
		this.on(this.$('.vjs-adblockers_detector-close'), 'click', () => {
			this.hide();
		});
	}

	init() {
		this.detectBlockers(() => {
			this.player_.addClass('vjs-adblockers_detector-detected');
			this.fillWith(this.createContent());
			this.setListeners_();
			this.show();
			this.options.onDetected && this.options.onDetected(this.player_);
			this.options.detectStatUrl && this.sendBlockerStat();
		});
	}

	show() {
	    super.show();
	}

	hide() {
	    super.hide();
	}

	createContent() {
		return [
			this.createClose_(),
			this.createHeading_(), 
			this.createMessage_()
		];
	}

	buildCSSClass() {
		return `vjs-adblockers_detector-message ${super.buildCSSClass()}`;
	}

	createClose_() {
		let close = dom.createEl('span', {
			className: 'vjs-adblockers_detector-close'
		});
		dom.insertContent(close, '\u00D7');
		return close;
	}

	createHeading_() {
		let heading = dom.createEl('div', {
			className: 'vjs-adblockers_detector-caption'
		}, {
			'role': 'heading'
		});
		dom.insertContent(heading, this.localize(this.options.caption));
		return heading;
	}

	createMessage_() {
		let content = dom.createEl('div', {
			className: 'vjs-adblockers_detector-content'
		});
		dom.insertContent(content, this.localize(this.options.message));
		return content;
	}

	detectBlockers(cb) {
		if (this.options.detectLink) {
			this.detectBlockersByLink(cb);
		} else {
			this.detectBlockersByElement(cb);
		}
	}

	detectBlockersByLink(cb) {
		let test = new XMLHttpRequest();
		test.open('HEAD', this.options.detectLink, true);
		test.onerror = (error) => {
			if (test.status === 0 && error instanceof ProgressEvent) {
				cb && cb();
			}
		};
		test.send();
	}

	detectBlockersByElement(cb) {
		let test = document.createElement('div');

		test.innerHTML = '&nbsp;';
		test.className = this.options.detectClass;
		document.body.appendChild(test);
		window.setTimeout(function() {
		  if (test.offsetHeight === 0) {
		    cb && cb();
		  }
		  test.remove();
		}, 300);
	}

	sendBlockerStat() {
		var blockerStatRequest = new XMLHttpRequest();
		blockerStatRequest.open('GET', this.options.detectStatUrl);
		blockerStatRequest.send();
	}
}

Component.registerComponent('ABDM', AdBlockersDetectorMessage);
export default AdBlockersDetectorMessage;